module.exports = __webpack_public_path__ + "img/arrow.b8eb7d81.svg";